import React, { useState } from 'react';
import ExpandableRow from 'components/common/expandable-row-component';
import SectionDetailsHistoryElement from 'components/feature/section-details-panel/_section-details-history-element-component';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConditionalRender from 'components/util/conditional-render-component';
import { SIGN_OFF_HISTORY_OPTIONS } from 'constants/feature/section-details-constants';
const SECTION_DETAILS_HISTORY = 'section-details-history';

export const SectionDetailsHistoryRow = ({
  sectionHistory,
  isOCR,
  projectUsersList,
}) => {
  const [showHistory, setShowHistory] = useState(true);
  const reviewAction = isOCR ? 'bookmarkAction' : 'sectionAction';

  return (
    <ExpandableRow
      title="section-panel.history.title"
      showExpandableRow={showHistory}
      minimizeExpandableRow={() => setShowHistory(false)}
      expandExpandableRow={() => setShowHistory(true)}
      tooltipId={`${SECTION_DETAILS_HISTORY}-history__tooltip`}
    >
      <ConditionalRender dependencies={[sectionHistory]}>
        {sectionHistory.data.sectionReviewHistory &&
          sectionHistory.data.sectionReviewHistory.result &&
          sectionHistory.data.sectionReviewHistory.result
            .filter(
              (review) =>
                review[reviewAction] !== SIGN_OFF_HISTORY_OPTIONS.ASSIGN_BY &&
                review[reviewAction] !== SIGN_OFF_HISTORY_OPTIONS.UNASSIGN_BY,
            )
            .map((history) => (
              <div key={history.id}>
                <SectionDetailsHistoryElement
                  history={history}
                  projectUsersList={projectUsersList}
                  isOCR={isOCR}
                />
              </div>
            ))}
      </ConditionalRender>
    </ExpandableRow>
  );
};

const mapStateToProps = ({
  data: {
    selectedStatement: { isOCR },
    sectionPanel: { sectionReviewHistory },
    projectUsersList,
  },
}) => ({
  sectionHistory: sectionReviewHistory,
  isOCR,
  projectUsersList,
});

SectionDetailsHistoryRow.propTypes = {
  /** history object from the section detail store */
  sectionHistory: PropTypes.object.isRequired,
  /** check if the history is shown for ocr or legacy */
  isOCR: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(SectionDetailsHistoryRow);
